export class NotificationSearchReq {
    take!: number;
    unreadOnly!: boolean;

    constructor(obj: Partial<NotificationSearchReq>) {
        Object.assign(this, obj);
    }
}